import { Type, Expose } from "class-transformer";
import { MasterMaterialModel } from "./master_material";
import { InstallationSectionModel } from "./event_detail_install";

export class OnEventCustomerModel {
  customerName: string = "";
  customerContact: string = "";
  customerEmail: string = "";
}

export class OnEventTechnicianModel {
  firstName: string = "";
  lastName: string = "";
}

export class OnEventShiptoModel {
  eventDate: string | null = null;
  shiptoDate: string | null = null;
  shiptoAddress: string = "";
  shiptoName: string = "";
  shiptoContact: string = "";
  startInstallDate: string | null = null;
  endInstallDate: string | null = null;

  @Type(() => OnEventCustomerModel)
  customer: OnEventCustomerModel = new OnEventCustomerModel();

  @Type(() => OnEventTechnicianModel)
  technicians: OnEventTechnicianModel[] = [];
}

export class OnEventTaskModel {
  eventId?: number;
  questType: string = "";
  netTotal: number | null = null;
  depositAmount: number | null = null;
  receivedAmount: number | null = null;
  isEnable?: boolean = true;
  isEdit?: boolean = true;
  questName?: string = "";

  @Expose({ name: "paymentAmount" })
  get paymentAmount(): number {
    return (Number(this.depositAmount) || 0) + (Number(this.receivedAmount) || 0);
  }

  @Expose({ name: "remainingAmount" })
  get remainingAmount(): number {
    return Math.max(0, (Number(this.netTotal) || 0) - this.paymentAmount);
  }
}

export class OnEventModel {
  @Type(() => OnEventShiptoModel)
  shipto: OnEventShiptoModel = new OnEventShiptoModel();

  @Type(() => OnEventTaskModel)
  quests: OnEventTaskModel[] = [];
}

export class UpdateOnEventDetailModel {
  receivedAmount: number = 0;
  afterImgUrls: string[] = [];
  products?: MasterMaterialModel[] = [];
  equipment?: MasterMaterialModel[] = [];
  reason?: string = "";
  isCompleted?: boolean = false;
}

export class UpdateOnEventInstallationModel {
  eventId: number = 0;
  isConfirm: boolean = false;

  @Type(() => InstallationSectionModel)
  equipment: InstallationSectionModel = new InstallationSectionModel();

  @Type(() => InstallationSectionModel)
  poppos: InstallationSectionModel = new InstallationSectionModel();

  @Type(() => InstallationSectionModel)
  serving: InstallationSectionModel = new InstallationSectionModel();

  signatureImgId: string = "";
}

